const mutations = {
  getPaxelBigExcellences: (state, paxel_big_excellence) => {
    state.paxel_big_excellence = paxel_big_excellence;
  },
  getPaxelBigExcellence: (state, paxel_big_excellence_id) => {
    state.paxel_big_excellence_id = paxel_big_excellence_id;
  },
  postPaxelBigExcellence: (state, new_paxel_big_excellence) => {
    state.paxel_big_excellence.push(new_paxel_big_excellence);
  },
  putPaxelBigExcellence: (state, payload) => {
    state.paxel_big_excellence = state.paxel_big_excellence.map((paxel_big_excellence) => {
      if (paxel_big_excellence.paxel_big_excellence_id === payload.id) {
        return Object.assign({}, paxel_big_excellence, payload.paxel_big_excellenceData);
      }
      return paxel_big_excellence;
    });
  },
  delPaxelBigExcellence(state, id) {
    const index = state.paxel_big_excellence.findIndex(paxel_big_excellence => paxel_big_excellence.paxel_big_excellence_id == id);
    state.paxel_big_excellence.splice(index, 1);
  },
};

export default mutations;
